import { useEffect, useState } from "react";
import { BellRing, CheckCircle2, ChevronRight, ChevronDown, Loader2, Phone, X, ShieldCheck, Copy, Check, Wrench } from "lucide-react";
import { toast } from "sonner";
import { Card } from "./ClienteCharts";
import { ProAlarmDialog } from "./ClienteAnalisiPro";

const quando = (s) => (s ? new Date(s).toLocaleString("it-IT", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

// riferimento breve e stabile della singola segnalazione (da citare all'installatore)
const riferimento = (a) => {
  const s = `${a.code || ""}-${a.quando || ""}`;
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h.toString(36).toUpperCase().padStart(4, "0").slice(0, 4);
};

function Spiegazione({ src, a, pro, onClose }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [copiato, setCopiato] = useState(false);
  const [form, setForm] = useState(false);
  const [msg, setMsg] = useState("");
  const [inviando, setInviando] = useState(false);
  useEffect(() => { src.allarme(a.code).then(setD).catch((e) => setErr(e.response?.data?.detail || "Spiegazione non disponibile, riprova tra poco")); }, [a.code]); // eslint-disable-line react-hooks/exhaustive-deps
  const tel = d?.installatore?.telefono;
  const rif = riferimento(a);
  const inviaIntervento = async () => {
    setInviando(true);
    try { await src.richiestaIntervento({ messaggio: msg, code: a.code }); toast.success("Richiesta inviata a Torri"); setForm(false); setMsg(""); }
    catch (e) { toast.error(e.response?.data?.detail || "Invio non riuscito, riprova"); }
    finally { setInviando(false); }
  };
  const copia = async () => {
    try {
      await navigator.clipboard.writeText(`Codice ${a.code || "—"} · Rif. ${rif}`);
      setCopiato(true);
      toast.success("Copiato: puoi incollarlo quando contatti il tuo installatore");
      setTimeout(() => setCopiato(false), 2000);
    } catch { toast.error("Copia non riuscita"); }
  };
  return (
    <div className="fixed inset-0 z-[85] flex items-end justify-center bg-slate-900/40 backdrop-blur-sm sm:items-center" onClick={onClose} data-testid="cliente-allarme-dialog">
      <div className="w-full max-w-md rounded-t-3xl bg-white p-5 shadow-2xl sm:rounded-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3">
          <span className={`rounded-2xl p-2 ${a.attivo ? "bg-amber-50 text-amber-600" : "bg-emerald-50 text-emerald-600"}`}>{a.attivo ? <BellRing className="h-6 w-6" /> : <ShieldCheck className="h-6 w-6" />}</span>
          <div className="min-w-0 flex-1"><b className="block text-slate-800">{a.tigo ? a.titolo : (a.attivo ? "Segnalazione in corso" : "Segnalazione rientrata")}</b><span className="text-xs text-slate-500">{a.tigo ? `Pannello ${a.etichetta} · riga ${a.riga}, colonna ${a.colonna}` : `${quando(a.quando)}${a.volte > 1 ? ` · ${a.volte} volte` : ""}`}</span></div>
          <button type="button" onClick={onClose} className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100" aria-label="Chiudi" data-testid="cliente-allarme-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="mt-4 min-h-[80px] text-sm leading-relaxed text-slate-700" data-testid="cliente-allarme-testo">
          {err || (d ? d.testo : <span className="flex items-center gap-2 text-slate-400"><Loader2 className="h-4 w-4 animate-spin" />Vesta sta preparando la spiegazione…</span>)}
        </div>
        <div className="mt-4 rounded-2xl bg-slate-50 p-3" data-testid="cliente-allarme-dettagli">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400">Dettagli per l'assistenza</span>
            <button type="button" onClick={copia} className="inline-flex items-center gap-1 rounded-full bg-white px-2.5 py-1 text-[11px] font-bold text-sky-600 ring-1 ring-slate-200 transition-colors hover:bg-sky-50" data-testid="cliente-allarme-copia">
              {copiato ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}{copiato ? "Copiato" : "Copia"}</button>
          </div>
          <div className="mt-2 grid grid-cols-2 gap-2">
            <div><span className="block text-[11px] text-slate-400">Codice segnalazione</span><b className="block font-mono text-sm text-slate-700" data-testid="cliente-allarme-codice">{a.code || "—"}</b></div>
            <div><span className="block text-[11px] text-slate-400">Riferimento</span><b className="block font-mono text-sm text-slate-700" data-testid="cliente-allarme-rif">{rif}</b></div>
          </div>
          <p className="mt-2 text-[11px] leading-snug text-slate-400">Questi codici servono solo al tuo installatore per aiutarti più in fretta.</p>
        </div>
        {pro && (
          <div className="mt-3 rounded-2xl bg-slate-100 p-3 ring-1 ring-slate-200" data-testid="cliente-allarme-tecnico">
            <span className="text-[11px] font-bold uppercase tracking-wider text-slate-500">Dettaglio tecnico · Pro</span>
            <div className="mt-2 grid grid-cols-2 gap-2 text-xs">
              <div><span className="block text-slate-400">Codice</span><b className="font-mono text-slate-700">{a.code || "—"}</b></div>
              <div><span className="block text-slate-400">Livello</span><b className="text-slate-700">{a.grave ? "Grave (2)" : "Avviso (1)"}</b></div>
              <div><span className="block text-slate-400">Occorrenze</span><b className="text-slate-700">{a.volte || 1}</b></div>
              <div><span className="block text-slate-400">Stato</span><b className="text-slate-700">{a.attivo ? "Attivo" : "Rientrato"}</b></div>
            </div>
          </div>
        )}
        {pro && src.richiestaIntervento && (form ? (
          <div className="mt-3 space-y-2" data-testid="cliente-intervento-form">
            <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={3} placeholder="Descrivi il problema (facoltativo)" data-testid="cliente-intervento-msg"
              className="w-full rounded-2xl border border-slate-200 p-3 text-sm outline-none focus:border-slate-400" />
            <div className="flex gap-2">
              <button type="button" onClick={() => setForm(false)} className="flex-1 rounded-2xl bg-slate-100 py-2.5 font-bold text-slate-700" data-testid="cliente-intervento-annulla">Annulla</button>
              <button type="button" onClick={inviaIntervento} disabled={inviando} data-testid="cliente-intervento-invia"
                className="flex flex-1 items-center justify-center gap-2 rounded-2xl bg-sky-500 py-2.5 font-bold text-white disabled:opacity-50">{inviando ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wrench className="h-4 w-4" />}Invia</button>
            </div>
          </div>
        ) : (
          <button type="button" onClick={() => setForm(true)} data-testid="cliente-intervento-apri"
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-800 py-3 text-sm font-bold text-white transition-transform active:scale-[0.98]"><Wrench className="h-4 w-4" />Apri richiesta d'intervento a Torri</button>
        ))}
        {d?.chiamare && (
          <a href={tel ? `tel:${tel}` : undefined} className="mt-4 flex items-center justify-center gap-2 rounded-2xl bg-sky-500 py-3 text-sm font-bold text-white" data-testid="cliente-allarme-chiama">
            <Phone className="h-4 w-4" />{tel ? `Chiama ${d.installatore.nome}` : `Contatta ${d.installatore.nome || "il tuo installatore"}`}</a>
        )}
      </div>
    </div>
  );
}

// Segnalazioni dell'impianto per il cliente: spiegate da Vesta senza dettagli tecnici
export function AllarmiCliente({ src, list, pro }) {
  const [open, setOpen] = useState(null);
  const [show, setShow] = useState(false);
  const attivi = list.filter((a) => a.attivo);
  const ok = !list.length || !attivi.length;
  return (
    <Card testid="cliente-allarmi">
      <button type="button" onClick={() => setShow((s) => !s)} className="flex w-full items-center justify-between gap-2" data-testid="cliente-allarmi-toggle">
        <span className="flex min-w-0 items-center gap-2 text-left">
          <CheckCircle2 className={`h-5 w-5 shrink-0 ${ok ? "text-emerald-600" : "text-amber-500"}`} />
          <span className="min-w-0">
            <b className="block text-base font-extrabold text-slate-800">Segnalazioni</b>
            <span className={`block truncate text-sm ${ok ? "text-emerald-700" : "text-amber-600"}`} data-testid="cliente-allarmi-riepilogo">
              {ok ? "Tutto funziona correttamente" : `${attivi.length} ${attivi.length === 1 ? "segnalazione attiva" : "segnalazioni attive"}`}{list.length ? ` · ${list.length} nello storico` : ""}</span>
          </span>
        </span>
        {list.length > 0 && <ChevronDown className={`h-5 w-5 shrink-0 text-slate-400 transition-transform ${show ? "rotate-180" : ""}`} />}
      </button>
      {show && list.length > 0 && <>
        <p className="mb-2 mt-3 text-sm text-slate-500">Tocca una segnalazione: Vesta ti spiega cosa significa.</p>
        <div className="space-y-2">
          {[...attivi, ...list.filter((a) => !a.attivo)].slice(0, 6).map((a, i) => (
            <button type="button" key={`${a.code}-${i}`} onClick={() => setOpen(a)} data-testid={`cliente-allarme-${i}`}
              className="flex w-full items-center gap-3 rounded-2xl bg-slate-50 p-3 text-left transition-colors hover:bg-slate-100">
              <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${a.attivo ? (a.grave ? "bg-red-500" : "bg-amber-400") : "bg-emerald-500"}`} />
              <span className="min-w-0 flex-1"><b className="block truncate text-sm text-slate-800">{a.tigo ? a.titolo : (a.attivo ? "Segnalazione in corso" : "Rientrata, tutto regolare")}</b>
                <span className="text-xs text-slate-500">{a.tigo ? `Modulo in ${a.attivo ? "allarme" : "regola"} · riga ${a.riga}, col. ${a.colonna}` : `${quando(a.quando)}${a.volte > 1 ? ` · ${a.volte} volte` : ""}`}</span></span>
              <ChevronRight className="h-4 w-4 shrink-0 text-slate-400" />
            </button>
          ))}
        </div>
      </>}
      {open && (pro && src.headers && !open.tigo
        ? <ProAlarmDialog src={src} alarm={open} onClose={() => setOpen(null)} />
        : <Spiegazione src={src} a={open} pro={pro} onClose={() => setOpen(null)} />)}
    </Card>
  );
}
